// extracted by mini-css-extract-plugin
export default {"container":"MenuContainer_container__UfUyT","column":"MenuContainer_column__vG4Nk"};